import React, { createContext, useContext, useEffect, useState } from 'react';

import { Storage } from "../../../utilities/setting";

const FloatingPanelContext = createContext();

export const useFloatingPanel = () => useContext(FloatingPanelContext);

export const FloatingPanelProvider = ({ children }) => {
  const [showPhone, setShowPhone] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [positions, setPositions] = useState({
    panelPhone: { x: 0, y: 0 },
    panelHistory: { x: 0, y: 0 },
    panelForm: { x: 0, y: 0 },
  });
  const [isMinimized, setIsMinimized] = useState(false)

  useEffect(() => {
    const load = async () => {
      const keys = [
        'showPhone', 'showHistory', 'showForm',
        'positionPhone', 'positionHistory', 'positionForm'
      ];
      const entries = await Storage.multiGet(keys);
      const values = Object.fromEntries(entries);

      setShowPhone(values.showPhone === 'true');
      setShowHistory(values.showHistory === 'true');
      setShowForm(values.showForm === 'true');

      let xValueDivisorValue;
      if (window.innerWidth > 1110) {
        xValueDivisorValue = 0.27;
      } else {
        xValueDivisorValue = 0.15;
      }

      setPositions({
        panelPhone: JSON.parse(values.positionPhone || JSON.stringify({ x: ((window.innerWidth / 2)) * xValueDivisorValue, y: -75 })),
        panelHistory: JSON.parse(values.positionHistory || '{"x":0,"y":0}'),
        panelForm: JSON.parse(values.positionForm || '{"x":0,"y":0}'),
      });
    };

    load();
  }, []);

  useEffect(() => {
    Storage.setItem('showPhone', String(showPhone));
  }, [showPhone]);

  useEffect(() => {
    Storage.setItem('showHistory', String(showHistory));
  }, [showHistory]);

  useEffect(() => {
    Storage.setItem('showForm', String(showForm));
  }, [showForm]);

  const togglePhone = () => setShowPhone(prev => !prev);
  const toggleHistory = () => setShowHistory(prev => !prev);
  const toggleForm = () => setShowForm(prev => !prev);
  const toggleMinimized = () => setIsMinimized(prev => !prev);

  const updatePosition = (id, x, y) => {
    const pos = { x, y };
    setPositions(prev => ({ ...prev, [id]: pos }));
    Storage.setItem(`position${id.replace("panel", "")}`, JSON.stringify(pos));
  };

  return (
    <FloatingPanelContext.Provider value={{
      showPhone, showHistory, showForm,
      togglePhone, toggleHistory, toggleForm,
      positions, updatePosition, toggleMinimized, isMinimized
    }}>
      {children}
    </FloatingPanelContext.Provider>
  );
};
